export const convertVideoLink = (link?: string) => {
    if (!link) return ""

    const youtubeMatch = link.match(
        /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/,
    )
    if (youtubeMatch) return `https://www.youtube.com/embed/${youtubeMatch[1]}?rel=0`

    const facebookMatch = link.match(/(?:https?:\/\/)?(?:www\.)?facebook\.com\/.*\/videos\/(\d+)/)
    if (facebookMatch) return `https://www.facebook.com/video/embed?video_id=${facebookMatch[1]}`

    const tiktokMatch = link.match(/(?:https?:\/\/)?(?:www\.)?tiktok\.com\/@(\w+)\/video\/(\d+)/)
    if (tiktokMatch) return `https://www.tiktok.com/embed/${tiktokMatch[2]}`

    return link
}